/**
 * Element-type registry (docs/08 §2 extension point): adding a floating
 * element type = adding a folder here + one registry entry. The canvas layer
 * looks types up here and never special-cases them.
 */
import type { ElementType } from "@kola/shared";
import type { ComponentType } from "react";

import { DrawingElementView } from "./drawing/DrawingElement.js";
import { FileElementView } from "./file/FileElement.js";
import { ImageElementView, type ElementRendererProps } from "./image/ImageElement.js";
import { LinkCardElementView } from "./linkCard/LinkCardElement.js";
// Side-effect imports: a type's folder also owns its F-27 toolbar entry
// (docs/08 §2) — the link card's is "Open in browser", the file folder's is
// "Download" (for every element that carries a file, images included).
// Registered here so pulling in the element-type registry pulls in every
// part of every type — the toolbar itself stays ignorant of what a link card
// or a file is. Idempotent (registerToolbarAction replaces by id), so an HMR
// re-import is safe.
import "./linkCard/toolbar.js";
import "./linkCard/clip-toolbar.js";
import "./file/toolbar.js";

export type { ElementRendererProps };

export type ElementRenderer = ComponentType<ElementRendererProps>;

export const elementRenderers: Partial<Record<ElementType, ElementRenderer>> = {
  image: ImageElementView,
  "link-card": LinkCardElementView,
  drawing: DrawingElementView,
  file: FileElementView,
};
